import { render, staticRenderFns } from "./klaeventos.vue?vue&type=template&id=1d606cc7&scoped=true"
import script from "./klaeventos.vue?vue&type=script&lang=js"
export * from "./klaeventos.vue?vue&type=script&lang=js"
import style0 from "./klaeventos.vue?vue&type=style&index=0&id=1d606cc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d606cc7",
  null
  
)

export default component.exports